import { SVGProps } from "react";

function SvgComponent(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 16 16"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      {...props}
    >
      <g>
        <path
          d="M11,23.5c-0.128,0-0.256-0.049-0.354-0.146c-0.195-0.195-0.195-0.512,0-0.707L21.293,12L10.646,1.354
			c-0.195-0.195-0.195-0.512,0-0.707s0.512-0.195,0.707,0l11,11c0.195,0.195,0.195,0.512,0,0.707l-11,11
			C11.256,23.451,11.128,23.5,11,23.5z"
        />
      </g>
      <g>
        <path
          d="M2,23.5c-0.128,0-0.256-0.049-0.354-0.146c-0.195-0.195-0.195-0.512,0-0.707L12.293,12L1.646,1.354
			c-0.195-0.195-0.195-0.512,0-0.707s0.512-0.195,0.707,0l11,11c0.195,0.195,0.195,0.512,0,0.707l-11,11
			C2.256,23.451,2.128,23.5,2,23.5z"
        />
      </g>
    </svg>
  );
}

export default SvgComponent;
